import React from 'react'
import styles from './About.module.css';
import aboutImg from '../static/profil1.jpeg';
import Title from '../helper/Title';

const About = () => {
  return (
    <section className={styles.section} id="about">
      <Title className={styles.sectiontitle} title='about' subTitle='us'/>

    <div className={`${styles.sectioncenter} ${styles.aboutcenter}`}>
      <div className={styles.aboutimg}>
        <img
          src={aboutImg}
          className={styles.aboutphoto}
          alt="awesome beach"
        />
      </div>
      <article className={styles.aboutinfo}>
        <h3>explore the difference</h3>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
          quisquam harum nam cumque temporibus explicabo dolorum sapiente odio
          unde dolor?
        </p>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur
          quisquam harum nam cumque temporibus explicabo dolorum sapiente odio
          unde dolor?
        </p>
        <a href="#" className={styles.btn}>read more</a>
      </article>
    </div>
    </section>
  )
}

export default About